module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"lastSubmission":"(poslední {dateTime})","action":{"fill":"Vyplnit formulář"}},"de":{"lastSubmission":"(zuletzt {dateTime})","action":{"fill":"Formular ausfüllen"}},"es":{"lastSubmission":"(último {dateTime})","action":{"fill":"Llenar formulario"}},"fr":{"lastSubmission":"(dernière {dateTime})","action":{"fill":"Remplir le formulaire"}}}')
  delete Component.options._Ctor
}
